// 1977 Topps Star Wars Series 2 — GENERATED by pipeline-publish (2026-05-30)
// =============================================================================
// Auto-generated from the set draft. Colors, sub-set types, ordering, and the
// SET_REGISTRY entry below are filled in. REVIEW before committing:
//   - Any placeholder color marker (a parallel name not in the standard color
//     map; the commit guard blocks until every one is resolved).
//   - Rule-7 base serial slots on numbered auto/sketch sub-sets (see in-array
//     notes; the warnings list above flags only sub-sets actually missing one).
//   - Sanity-check the auto-classified sub-set `type` and ordering.
//   - Any placeholder in the SET_REGISTRY entry below (only present if no DB
//     sets row exists for this slug, or fields are blank).
//   - A source/specimen pass on parallel names + print runs.
//   - node --check src/sets/1977-series-2.js if committing by hand, then commit + push.
//
// SET_REGISTRY entry (paste into src/setRegistry.js):
//   {
//     id: "1977-series-2",
//     name: "1977 Topps Star Wars Series 2",
//     shortName: "Series 2 1977",
//     year: 1977,
//     brand: "Topps",
//     category: 'Star Wars',
//     releaseDate: "1977",
//     totalCards: 77,
//     description: "Topps 1977 Topps Star Wars Series 2 trading card set.",
//     color: "#888aa0",
//     accentColor: "#f0c040",
//     dataFile: "1977-series-2",
//   },
// =============================================================================

export const SETS = [
  {
    id: "base",
    type: "base",
    title: "BASE",
    parallels: [],
    cards: [
        { n: "67", name: "See-Threepio and Luke" },
        { n: "68", name: "The Millennium Falcon" },
        { n: "69", name: "Threepio's Desert Track" },
        { n: "70", name: "Special Mission for Artoo-Detoo" },
        { n: "71", name: "The Incredible See-Threepio" },
        { n: "72", name: "Ben Kenobi Rescues Luke!" },
        { n: "73", name: "The Droids Wait For Luke" },
        { n: "74", name: "Luke Skywalker on Tatooine" },
        { n: "75", name: "Darth Vader Strangles a Rebel" },
        { n: "76", name: "Artoo-Detoo on the Rebel Starship!" },
        { n: "77", name: "Waiting in the Control Room" },
        { n: "78", name: "Droids to the Rescue" },
        { n: "79", name: "Preparing to Board Solo's Starship!" },
        { n: "80", name: "\"Where has R2-D2 Gone?\"" },
        { n: "81", name: "Weapons of the Death Star" },
        { n: "82", name: "A Daring Rescue!" },
        { n: "83", name: "Aboard the Millennium Falcon" },
        { n: "84", name: "Rebel Pilot Prepares for the Raid!" },
        { n: "85", name: "Luke on the Sand Planet" },
        { n: "86", name: "A Mighty Explosion!" },
        { n: "87", name: "The Droids Try to Rescue Luke!" },
        { n: "88", name: "Stormtroopers Guard Solo's Ship" },
        { n: "89", name: "The Imprisoned Princess Leia" },
        { n: "90", name: "Honoring the Victors!" },
        { n: "91", name: "Solo and Chewie Prepare to Leave Luke" },
        { n: "92", name: "Advance of the Tusken Raider" },
        { n: "93", name: "Stormtroopers Blast the Rebels!" },
        { n: "94", name: "Interrogated by Stormtroopers" },
        { n: "95", name: "Sighting Artoo-Detoo!" },
        { n: "96", name: "The Droids on Tatooine" },
        { n: "97", name: "Meeting at the Cantina" },
        { n: "98", name: "See-Threepio" },
        { n: "99", name: "Ben with the Light Saber!" },
        { n: "100", name: "Our Heroes at the Spaceport" },
        { n: "101", name: "The Wookiee Chewbacca" },
        { n: "102", name: "Rebels Prepare for the Big Fight!" },
        { n: "103", name: "Stormtroopers Attack Our Heroes" },
        { n: "104", name: "Luke's Aunt and Uncle" },
        { n: "105", name: "Imperial Soldiers Burn Through the Starship!" },
        { n: "106", name: "A Message From Princess Leia!" },
        { n: "107", name: "The Tusken Raider" },
        { n: "108", name: "Princess Leia Observes the Battle" },
        { n: "109", name: "Ben Turns Off the Tractor Beam" },
        { n: "110", name: "Threepio Fools the Guards!" },
        { n: "111", name: "Chewie and Han Solo!" },
        { n: "112", name: "Threatened by Sand People!" },
        { n: "113", name: "Ben Hides From Imperial Stormtroopers" },
        { n: "114", name: "Planning to Escape!" },
        { n: "115", name: "Hiding in the Millennium Falcon!" },
        { n: "116", name: "Honored for Their Heroism!" },
        { n: "117", name: "Chewbacca Poses as a Prisoner" },
        { n: "118", name: "R2-D2 and C-3P0" },
        { n: "119", name: "Threepio, Ben and Luke!" },
        { n: "120", name: "Luke Destroys an Imperial Ship!" },
        { n: "121", name: "Han Solo and Chewbacca" },
        { n: "122", name: "The Millennium Falcon Speeds Through Space!" },
        { n: "123", name: "See-Threepio Blasts a Stormtrooper!" },
        { n: "124", name: "Threepio Searches for R2-D2" },
        { n: "125", name: "Luke in Disguise!" },
        { n: "126", name: "A Quizzical Threepio!" },
        { n: "127", name: "The Rebel Fleet" },
        { n: "128", name: "Roar of the Wookiee!" },
        { n: "129", name: "\"May the Force be With You!\"" },
        { n: "130", name: "Pursued by the Jawas" },
        { n: "131", name: "Spectacular Battle!" },
        { n: "132", name: "Lord Vader and a Soldier" },
    ],
  },
  {
    id: "sticker",
    type: "insert",
    title: "STICKER",
    parallels: [],
    cards: [
        { n: "12", name: "Han and Chewbacca" },
        { n: "13", name: "Alec Guinness as Ben" },
        { n: "14", name: "The Tusken Raider" },
        { n: "15", name: "See-Threepio" },
        { n: "16", name: "Chewbacca" },
        { n: "17", name: "Threatened by Sand People!" },
        { n: "18", name: "The Rebel Fleet" },
        { n: "19", name: "The Wookiee Chewbacca" },
        { n: "20", name: "R2-D2 and C-3P0" },
        { n: "21", name: "The Millennium Falcon Speeds Through Space!" },
        { n: "22", name: "Spectacular Battle!" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
